import useCapabilities, { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";

export function usePersonEducationCapability() {
  const { loaded } = useCapabilities();
  const canViewPersonEducation = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonEducation
  });

  return {
    loaded,
    canViewPersonEducation
  };
}

/** Capability check for education routes. Denied users are redirected by `education/_TabLayout` or route-local `Navigate`. */
export function usePersonEducationAccess() {
  return usePersonEducationCapability();
}
